module.exports = __webpack_public_path__ + "components/page-header/static/icon-mountain-c4510c693b51d7e7e3e2a98e425efd52.svg";